const pearl = {
  pearl: 'Pearl',
  amountTips: 'Gönderim için minimum pearl: {{ num }}',
  selectUserTips: 'Alıcının hesabını girin',
  inputAmountTips: 'Gönderilecek miktarı girin',
};

export default {
  title: 'Gönder',
  success: 'Başarıyla gönderildi',
  transfer: 'Transfer',
  transfering: 'Transfer ediliyor...',
  successTips: 'Gönderdiğiniz ID ve miktarı kontrol edin',
  sellResultTitle: 'Coin için',
  sellSuccessMain: 'Değişim Başarılı',
  sellFailureDescription:
    'Mevcut işlem anormal, lütfen işlem detaylarına giderek sonucu doğrulayın',
  pearl,
};
